<template>
    <section class="px-3 py-10 lg:p-12">
        <div class="flex justify-between items-center py-3 border-b border-black">
            <p class="lg:uppercase">{{ folder.subtitle }}</p>
            <p v-if="folder.date" class="lg:w-[350px]">{{ formatDate(folder.date, "DD.MM.YY") }}</p>
        </div>

        <p class="mt-10 mb-40 text-lg lg:w-[350px] lg:ml-auto" v-html="folder.intro">

        </p>

        <p v-if="folder.description" class="my-20 text-lg lg:w-3/4 lg:text-4xl" v-html="folder.description">

        </p>

        <div class="text-sm lg:text-xl">
            <div class="relative">
                <p v-if="folder.text_1" class="w-2/3 lg:w-[500px] lg:mx-auto" v-html="folder.text_1">

                </p>

                <div v-if="folder.text_2" class="flex justify-end">
                    <p class="w-2/3 lg:w-[50%]" v-html="folder.text_2">

                    </p>
                </div>

                <p v-if="folder.text_3" class="w-2/3 mb-20 lg:w-[500px] lg:mx-auto" v-html="folder.text_3">

                </p>

                <div v-if="folder.text_4" class="flex justify-end mb-10 lg:absolute lg:top-[50%] lg:-translate-y-[50%] lg:-left-[40px] xl:-left-[20px]">
                    <p class="w-2/3 lg:w-[300px] lg:text-lg" v-html="folder.text_4">
                   }
                    </p>
                </div>
            </div>

            <div class="relative lg:min-h-[300px]">
                <div v-if="folder.public_image_1_path" class="lg:flex lg:justify-end">
                    <img
                        class="object-cover object-center h-[160px] w-[250px] lg:h-[550px] lg:w-[50%]"
                        :src="folder.public_image_1_path"
                        alt=""
                    >
                </div>

                <div v-if="folder.public_image_2_path" class="flex justify-end mt-8 mb-20 lg:m-0 lg:absolute lg:left-0 lg:top-[50%] lg:-translate-y-[50%]">
                    <img
                        class="object-cover object-center h-[100px] w-[120px] lg:w-[370px] lg:h-[320px]"
                        :src="folder.public_image_2_path"
                        alt=""
                    >
                </div>

                <div v-if="folder.text_5" class="flex justify-end mb-28 lg:mt-20">
                    <p class="w-2/3 lg:w-[50%]" v-html="folder.text_5">

                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import AtomFolderTitleOpaque from "../atoms/AtomFolderTitleOpaque.vue";
import {mapState} from "vuex";
import AtomButtonArrowRight from "../../global/atoms/AtomButtonArrowRight.vue";
import {formatDate} from "../../../utils/formatDate";

export default {
    name: 'OrganismFolderAbout',
    methods: {formatDate},
    components: {AtomButtonArrowRight, AtomFolderTitleOpaque},
    computed: {
        ...mapState({
            folder: state => state.folder.folder
        })
    }
}
</script>
